<div id="globalSearch" class="wx-256 hx-28 fs-4 rounded-3 searchbox d-flex justify-content-between align-items-center px-2" (click)="openSearch(searchModal)">
  <span>
    <svg viewBox="0 0 8 8" class="icon" inlineSVG="#magnifying-glass"></svg>
    Search
  </span>
  <span>Alt+Q</span>
</div>

<ng-template #searchModal>
  <div *transloco="let t; read: 'ime.components.global-search'">
    <div class="modal-header bg-gray-100 border-bottom-0 flex-column" ngxModalDraggable>
      <input #globalSearch type="search" class="form-control w-100 fs-4" [placeholder]="t('Search')" (input)="search(globalSearch.value)" (keydown)="onkeydown($event)"/>
      <div *ngIf="!globalSearch.value && lastSearch" (click)="globalSearch.value = lastSearch" class="ms-auto text-muted mb-n4" style="cursor: pointer">
        <span class="pi pi-history me-1 mt-1"></span>{{lastSearch}}
      </div>
    </div>
    <div class="modal-body p-1 fs-4 bg-gray-100" style="max-height: 90vh;">
      <div *ngFor="let groupedResult of groupedResults; let groupIndex = index">
        <a (click)="groupedResult.IsCollapsed = !groupedResult.IsCollapsed" [className]="groupIndex === activeGroup && activeRow == null ? 'border rounded-3 border-2 border-primary-subtle' : ''" id="group-{{groupIndex}}">
          <svg viewBox="0 0 8 8" class="icon me-1 text-default" [inlineSVG]="groupedResult.IsCollapsed ? '#chevron-right' : '#chevron-down'"></svg>
          <span class="{{groupedResult.CssClass}} badge">
            {{groupedResult.Name}}</span>
          <span class="text-muted fs-3 ms-1">{{groupedResult.Length}}
            <ng-container *ngIf="groupedResult.Results.length === 100">+</ng-container></span>
        </a>
        <ng-container *ngIf="!groupedResult.IsCollapsed">
          <div class="d-flex justify-content-between text-wrap text-break rounded-1 mt-1 {{groupIndex === activeGroup && rowIndex === activeRow ? 'bg-primary-subtle' : 'bg-white'}}"
               *ngFor="let result of groupedResult.Results; let rowIndex = index; trackBy: trackById" id="row-{{groupIndex}}-{{rowIndex}}" (mouseenter)="onMouseEnter(groupIndex, rowIndex)" (mouseleave)="removeResultFocus()">
            <div (click)="open(result, 'default')" style="cursor: pointer">
              <svg viewBox="0 0 8 8" class="icon mb-1" inlineSVG="#stop"
                   [class.text-secondary]="result.Type === entityTypes.Item"
                   [class.text-primary]="result.Type === entityTypes.ItemGroup"
                   [class.text-info]="result.Type === entityTypes.Resource"
                   [class.text-indigo-400]="result.Type === entityTypes.Property"
                   [class.text-warning]="result.Type === favouritesType"></svg>
              <span [ngOptionHighlight]="globalSearch.value">{{result | displayName}}</span>
              <span *ngIf="result.IsDraft" class="badge bg-default" title="Draft">D</span>
            </div>
            <div class="my-auto m-1" style="white-space: nowrap" *ngIf="result.Type !== favouritesType && groupIndex === activeGroup && rowIndex === activeRow">
              <a class="{{activeBtn == 1 ? 'border rounded-3 border-2 border-primary' : ''}}" (click)="open(result, 'blank')" [title]="t('Open in new tab')">
                <svg viewBox="0 0 8 8" class="icon mx-1 mb-1 text-primary" inlineSVG="#arrow-top-right-on-square"></svg>
              </a>
              <a class="{{activeBtn == 2 ? 'border rounded-3 border-2 border-primary' : ''}}" (click)="open(result, 'modal')" [title]="t('Open in modal')">
                <svg viewBox="0 0 8 8" class="icon mx-1 mb-1 text-primary" style="stroke-width: 1.5px; fill: transparent"  inlineSVG="#o-square-2-stack"></svg>
              </a>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

